// extracted by mini-css-extract-plugin
export default {"saveCancel":"SettingsUtils_saveCancel__riaM+"};